import { Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";

import TourList from "./pages/TourList";
import TourDetails from "./pages/TourDetails";

function App() {
  return (
    <div>
     

      <Routes>
        <Route path="/" element={<TourList />} />
        <Route path="/tour/:id" element={<TourDetails />} />
        <Route path="/about" element={<About />} />
       
      </Routes>
    </div>
  );
}

export default App;